import * as styles from "./Breadcrumbs.module.scss";

import React from "react";
import { Helmet } from "react-helmet-async";
import useWindowLocationHref from "../../hooks/useWindowLocationHref";
import useWindowWidth from "../../hooks/useWindowWidth";
import { Colours } from "../../utils/colours";
import { Chevron, Home } from "../common/Icons";
import LinkNoStyle from "../common/LinkNoStyle/LinkNoStyle";

export interface BreadcrumbsProps {
	breadcrumbs: DogsTrust.Breadcrumb[];
	disableLinks: boolean;
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
	breadcrumbs = [],
	disableLinks,
}) => {
	const windowWidth = useWindowWidth();
	const { windowLocationHref } = useWindowLocationHref();
	const safeBreadCrumbs =
		windowWidth < 600
			? breadcrumbs.slice(-2).map((breadcrumb) => ({
					...breadcrumb,
					title:
						breadcrumb.title.length > 15
							? `${breadcrumb.title.slice(0, 15).trim()}...`
							: breadcrumb.title,
				}))
			: breadcrumbs;
	const thisPage = breadcrumbs[breadcrumbs.length - 1];
	return (
		<>
			<Helmet>
				<script type="application/ld+json">
					{JSON.stringify({
						"@context": "https://schema.org",
						"@type": "BreadcrumbList",
						itemListElement: [
							{
								"@type": "ListItem",
								position: 1,
								name: "Home",
								item: process.env.GATSBY_DOMAIN_NAME,
							},
							...breadcrumbs.slice(0, -1).map((breadcrumb, i) => ({
								"@type": "ListItem",
								position: i + 2,
								name: breadcrumb.title,
								item: `${process.env.GATSBY_DOMAIN_NAME}${breadcrumb.url}`,
							})),
							thisPage && {
								"@type": "ListItem",
								position: breadcrumbs.slice(0, -1).length + 2,
								name: thisPage.title,
								item: windowLocationHref,
							},
						],
					})}
				</script>
			</Helmet>
			<div className={styles.breadcrumbswrapper}>
				<LinkNoStyle
					to={"/"}
					className={styles.breadcrumbdivider}
					ariaLabel={"Dog's Trust Homepage"}
					tabIndex={disableLinks ? -1 : 0}
				>
					<Home height={"24px"} width={"24px"} fill={Colours.DAWN} />
				</LinkNoStyle>
				{safeBreadCrumbs.map((breadcrumb) => (
					<div className={styles.breadcrumbs} key={breadcrumb.title}>
						<div className={styles.breadcrumbdivider}>
							<Chevron
								className={styles.chevron}
								rotation={90}
								height={"16px"}
								width={"16px"}
								fill={Colours.DAWN}
							/>
						</div>
						{breadcrumb.url?.length > 0 ? (
							<LinkNoStyle
								to={breadcrumb.url}
								className={styles.breadcrumb}
								title={breadcrumb.title}
							>
								{breadcrumb.title}
							</LinkNoStyle>
						) : (
							<div className={styles.breadcrumb} title={breadcrumb.title}>
								{breadcrumb.title}
							</div>
						)}
					</div>
				))}
			</div>
		</>
	);
};

export default Breadcrumbs;
